<template>
  <div class="head">
    <!-- logo -->
    <div class="top">
      <div class="left"></div>
    </div>
    <!-- 介绍 -->
    <div class="contentbox">
      <div class="title">
        <div class="logo">
          <img
            :src="
              'http://www.xinhuoa.com:2363/upload/' + Catedetails.more.thumbnail
            "
            alt=""
          />
        </div>
        <div v-if="Catedetails.name !== 'test'">{{ Catedetails.name }}</div>
        <div v-else>该产品没有添加品牌</div>
      </div>
      <div class="content">
        {{ Catedetails.description }}
      </div>
      <div
        class="back"
        @click="backbtn(Catedetails.parent_id)"
        v-show="pages == 1"
      >
        返回上级>>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    Catedetails: {
      type: Object,
      default: {},
    },
    pages: {
      type: String,
      default: 0,
    },
  },
  data() {
    return {}
  },

  created() {},
  mounted() {
    // console.log(Catedetails)
  },
  methods: {
    backbtn(e) {
      // alert(e)
      // console.log(e)
      this.$router.push({
        path: '/ProductList',
        query: {
          cid: e,
        },
      })
      // window.history.go(-1)
    },
  },
}
</script>
 
<style lang="less" scoped>
.head {
  cursor: pointer;
  width: 100vw;
  height: 11.9rem;
  display: flex;
  flex-direction: column;
  .top {
    width: 100vw;
    height: 1.9rem;
    // background: red;
    // display: flex;
    // justify-content: space-between;
    background: url('../../static/images/logo.png') no-repeat;
    background-size: 100% 100%;
  }
  .contentbox {
    position: relative;
    width: 100vw;
    height: 10rem;
    background: url('../../static/images/banner.png') no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    // box-sizing: content-box;
    padding: 2.08rem 2.13rem;
    .title {
      margin-bottom: 0.85rem;
      display: flex;
      //   align-items: center;

      .logo {
        width: 1.08rem;
        height: 1.12rem;
        margin-right: 0.34rem;
        display: inline-block;
      }
      div {
        // width: 3.11rem;
        height: 0.77rem;
        font-size: 0.8rem;
        font-family: OPPOSans;
        font-weight: bold;
        color: #333333;
      }
    }
    .content {
      width: 33.55rem;
      height: 2.3rem;
      font-size: 0.46rem;
      font-family: OPPOSans;
      font-weight: 500;
      color: #333333;
      line-height: 0.9rem;
    }
    .back {
      position: absolute;
      z-index: 9999;
      width: 2.8rem;
      height: 1rem;
      text-align: center;
      box-sizing: border-box;
      // line-height: 1rem;
      padding-top: 0.36rem;
      background: #fff;
      border: 0.02rem solid #009269;
      right: 0.7rem;
      bottom: 0.7rem;
      font-size: 0.42rem;
      font-family: OPPOSans;
      font-weight: 500;
      color: #009269;
      line-height: 0.19rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Head.vue